import { formatPrice, fetchProducts } from '~js/utils/products-and-collections';

// INHERITS cartItem in scope

const lineItemComponent = (lowStockThreshold, lowStockMessage, normalStockMessage) => ({
  lowStockThreshold,
  lowStockMessage,
  normalStockMessage,
  isRemoving: false,
  fullVariantData: {},

  async init() {
    const currentAllProducts = await fetchProducts([this.cartItem.product_id]);
    const cartItemProductData = currentAllProducts[this.cartItem.product_id];
    const cartItemVariantData = cartItemProductData.variants.find(
      (variant) => variant.id.replace('gid://shopify/ProductVariant/', '') === this.cartItem.variant_id.toString(),
    );
    this.fullVariantData = cartItemVariantData;
  },

  async removeItem(key, isGiftBox = false) {
    const { $store } = this;
    try {
      this.isRemoving = true;
      if (isGiftBox) {
        await $store.cart.clearGiftBoxAttributes();
      }
      await $store.cart.removeLineItem(key);
    } catch {
      alert('sorry, there was an error removing this item from your cart');
    } finally {
      this.isRemoving = false;
    }
  },

  async updateQuantity(quantity) {
    try {
      await this.$store.cart.changeLineItem({
        id: this.cartItem.key,
        quantity: quantity,
      });
    } catch (error) {
      alert(error.message);
    }
  },

  get imageUrl() {
    return this.cartItem.featured_image.url;
  },
  get imageAlt() {
    return this.cartItem.featured_image.alt;
  },
  get imageWidth() {
    return this.cartItem.featured_image.width;
  },
  get imageHeight() {
    return this.cartItem.featured_image.height;
  },

  get isLowStock() {
    const { fullVariantData, lowStockThreshold } = this;
    if (fullVariantData.quantityAvailable) {
      return fullVariantData.quantityAvailable <= lowStockThreshold;
    } else return true;
  },

  get discountStatus() {
    const { fullVariantData, cartItem } = this;
    if (cartItem.discounts.length) {
      return 'APPLIED';
    } else if (
      fullVariantData.compareAtPrice &&
      parseFloat(fullVariantData.compareAtPrice.amount) > parseFloat(fullVariantData.price.amount)
    ) {
      return 'MARKDOWN';
    }

    return null;
  },
  get originalPrice() {
    const { discountStatus, fullVariantData, $store, cartItem } = this;
    if (discountStatus === 'MARKDOWN') {
      const compareAtPrice = parseFloat(fullVariantData.compareAtPrice.amount);
      const { quantity } = cartItem;

      return formatPrice({
        currencyCode: $store.cart.cartData.currency,
        amount: compareAtPrice * quantity,
      });
    } else if (discountStatus === 'APPLIED') {
      return formatPrice({
        currencyCode: $store.cart.cartData.currency,
        amount: cartItem.original_line_price / 100,
      });
    }
    return '';
  },

  get finalPrice() {
    const { $store, cartItem } = this;

    return formatPrice({
      currencyCode: $store.cart.cartData.currency,
      amount: cartItem.final_line_price / 100,
    });
  },
});

export default lineItemComponent;
